module.exports = __webpack_public_path__ + "media/packs/App/assets/fonts/materialdesignicons-webfont-eacc60984c4a668938dd76cd0b2a952b.woff2";